import { PrecheckResponse } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { RequestApiUri } from './uri';

export class PrecheckApi {
  public static async getPrecheckReport(requestId: string) {
    const response = await Http.get<PrecheckResponse>(
      RequestApiUri.GET_PRECHECK_REPORT_URL(requestId)
    );
    return response.data;
  }
}
